import vue from 'vue'
import {nanoid} from "nanoid";

import {
  getDocumentManagePage,
  disabledDocumentPage, deleteDocumentPage, addDocumentPage, queryDocumentManage, editDocumentManagePage,
  releaseDocumentPage, queryDocumentType,
} from "../../../services/file/fileManage"

const state = {
  dataPages: [],
  detailsData: [],
  typeList: [],//文档分类list
  total: 0,
  paginationInit: {current: 1, size: 10},
  filterInit: {},
  savePreview: vue.ls.get('savePreview'),
}

const getters = {
  dataPages: () => state.dataPages,
  detailsData: () => state.detailsData,
  total: () => state.total,
  paginationInit: () => state.paginationInit,
  typeList: () => state.typeList,//文档分类list
  filterInit: () => state.filterInit,
  savePreview: () => state.savePreview ? state.savePreview : vue.ls.get('savePreview'),
}

const actions = {
  //文档管理列表
  getDocumentManagePage({commit, dispatch}, objc) {
    getDocumentManagePage({...state.filterInit, ...state.paginationInit}).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data.records});
        commit('updateState', {state: 'total', update: res.data.total});
      } else {
        commit('updateState', {state: 'dataPages', update: []});
        commit('updateState', {state: 'total', update: 0});
      }
    })
  },
  //根据ID查询
  queryDocumentManage({commit, dispatch}, objc) {
    queryDocumentManage(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'detailsData', update: res.data});
      }
    })
  },
  //查询分类
  queryDocumentType({commit, dispatch}, objc) {
    queryDocumentType(objc).then((res) => {
      if (res.code === 0 && res.data) {
        let list = [];
        if (res.data && res.data.length > 0) {
          res.data.map((i) => {
            list.push({name: i, id: i})
          })
        }
        commit('updateState', {state: 'typeList', update: list});
      }
    })
  },
  //编辑文档
  editDocumentManagePage({commit, dispatch}, objc) {
    editDocumentManagePage(objc.params).then((res) => {
      if (res.code === 0 && objc.route) {
        objc.route.go(-1);
      }
    })
  },

  //创建文档
  addDocumentPage({commit, dispatch}, objc) {
    addDocumentPage(objc.params).then((res) => {
      if (res.code === 0 && objc.route) {
        objc.route.go(-1)
      }
    })
  },

  //停用文档
  disabledDocumentPage({commit, dispatch}, objc) {
    disabledDocumentPage(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getDocumentManagePage')
      }
    })
  },

  //发布文档
  releaseDocumentPage({commit, dispatch}, objc) {
    releaseDocumentPage(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getDocumentManagePage')
      }
    })
  },

  //删除文档
  deleteDocumentPage({commit, dispatch}, objc) {
    deleteDocumentPage(objc).then((res) => {
      if (res.code === 0) {
        if (state.total % state.paginationInit.size === 1 && state.paginationInit.current === parseInt(state.total / state.paginationInit.size) + 1) {
          commit('updateState', {state: 'paginationInit', update: {...state.paginationInit, current: 1}})
          dispatch('getDocumentManagePage');
        } else {
          dispatch('getDocumentManagePage');
        }
      }
    })
  }
}

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
    if (payload.state === 'savePreview') {
      vue.ls.set(payload.state, payload.update);
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/file/modules/fileManage.js